import React from 'react';

import { MuiThemeProvider, withStyles, WithStyles } from '@material-ui/core/styles';
import { Theme } from "@material-ui/core/styles";

import { AppState, Actions, store, IPageState } from '../../appredux'
import { connect, Provider } from 'react-redux';

import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { Trans, WithTranslation, withTranslation } from 'react-i18next';
import FormControl from '@material-ui/core/FormControl';
import Checkbox from '@material-ui/core/Checkbox';
import DialogActions from '@material-ui/core/DialogActions';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';

import TextField from '@material-ui/core/TextField';


import { Ceny, DaneNIPGus, DaneNIPVies, dostepnoscPokoju, nipService, PokojOpcja, Result, RezerwacjaPobyt } from '../../api';
import { FieldTypes, FormFields, renderFields } from '../common/formFields/renderFields';
import { mobileBreakpoint, PoleDlugosciDwaWWierszu, PoleDlugosciJednoWWierszu } from '../common/formFields/formularzStaleWspolne';
import { TFunction } from 'i18next';
import { Form, Formik, FormikErrors, FormikProps, FormikTouched} from 'formik';
import { FormikTextFieldProps } from '../common/formFields/FormikTextField';
import { capitalizeFirstLetter, containsAnyLetter, sendErrorLog, selectTheme, daysFromDate, dwaMiejscaPoPrzecinku } from '../common/helpers';
import MuiCheckbox from 'app/common/formFields/MuiCheckbox';
import DialogComponent from 'app/common/DialogComponent';
import { Content } from 'app/Notifier';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import theme from 'themes/themes';

import CalculateIcon from '@mui/icons-material/Calculate';

import moment from 'moment';



type ModalProps = {
  page: IPageState,
  theme: string,
  options: PokojOpcja[],
  czyPobytZmieniany: boolean,
  zmienianyPobyt: RezerwacjaPobyt,
  openFormularzFaktura: number,
  optionsValues: string[],

  width: number,
  dostepnosc: dostepnoscPokoju[],
  fromDate: string
}

type ModalState = {
  
}

//const secondaryLight = theme.palette.secondary.light;

//let stylInputa : React.CSSProperties = {};
let stylInputa: React.CSSProperties = { padding: "8px 14px", fontWeight: "normal", textAlign: "left" };

class NotifierOptions extends React.Component<ModalProps & WithTranslation & WithStyles<typeof styles>, ModalState> {
  secondaryLight =   selectTheme(this.props.theme).palette.secondary.light;


  state = {

  };


  componentDidMount() {
    
  }

  
  //PM 2021-10-22
  //wstrzykniecie tylko uzywanych pol z magazynu danych
  async componentDidUpdate(prevProps: ModalProps) {
   
  }


  getDayOfWeek = (param: string) => {
    return moment(param).locale(this.props.page.lang).format('dddd');
}

  render() {
    const { t, classes } = this.props;

    let primary = theme.palette.primary.main
    let red = theme.palette.error.main


    let ceny : any[] = this.props.dostepnosc

    ceny = this.props.dostepnosc.map((x, index) => ({...x, cena_pokoj: dwaMiejscaPoPrzecinku(x.cena_pokoj.toString()), dzien_tygodnia: this.getDayOfWeek(daysFromDate(new Date(this.props.fromDate), index)), data: daysFromDate(new Date(this.props.fromDate), index) }))

    let nums = this.props.dostepnosc.map(x => x.cena_pokoj )
    let sum = 0
    nums.forEach(num => {
      sum += num;
    })
    sum = sum / this.props.dostepnosc.length
    //let roomPrice = Math.round(sum).toFixed(2).split(".").join(",") //do całości
    let roomPrice = Number(sum).toFixed(2).split(".").join(",")  //dokładnie
        

    ceny.push({
      dzien_tygodnia: 'cena średnia',
      data: '',
      cena_pokoj: roomPrice,
      pokoj: 0,
      opis: '',
      ilosc_miejsc: 0,
      ktora_cena: 0,
      cena_brak: 0,
      cena_os1: 0,
      cena_os2: 0,
      cena_os3: 0,
      cena_os4: 0,
    })


    return (
      <>
      <p style={{padding: "2px", margin: "11px"}}></p>
        <TableContainer  sx={{ maxHeight: 319, marginLeft: this.props.width < 600 ? "0" : "-6px" }} style={{marginBottom: "50px"}}>
          <Table sx={{}} style={{width: '300px', margin: "0 auto"}} color='primary'> {/*width: "auto"*/}
            <TableHead>
              <TableRow>
                {/* <TableCell style={{  width: "10px", }} className={classes.header}></TableCell> */}
                <TableCell style={{ textAlign: "center", borderRight: "1px solid rgba(224, 224, 224, 1)" }} className={classes.header}>data</TableCell>
                <TableCell style={{ borderRight: "1px solid rgba(224, 224, 224, 1)" }} className={classes.header}>dzień</TableCell>
                <TableCell style={{textAlign: "center",}} className={classes.header}>cena</TableCell>
                {/* <TableCell align="right">Carbs&nbsp;(g)</TableCell>
            <TableCell align="right">Protein&nbsp;(g)</TableCell> */}
              </TableRow>
            </TableHead>
            <TableBody>
              {ceny.map((row : any, index : number) => (
                <TableRow
                  key={index}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                  style={{background: index % 2 === 0 ? "inherit" : "rgb(240, 240, 240)" }}
                >
                  {/* <TableCell style={{  width: "10px" }} className={classes.cell} color='primary'></TableCell> */}
                  <TableCell style={{ textAlign: "center", borderRight: "1px solid rgba(224, 224, 224, 1)", color: row.dzien_tygodnia === "sobota" || row.dzien_tygodnia === "niedziela" ? red : primary, width: "90px", fontSize:  "12px", }} className={classes.cell} color='primary'>{row.data}</TableCell>
                  <TableCell style={{ background: index +1 === ceny.length ? "rgb(240, 255, 235)" : "inherit", borderRight: "1px solid rgba(224, 224, 224, 1)", color: row.dzien_tygodnia === "sobota" || row.dzien_tygodnia === "niedziela" ? red : primary, fontWeight: index +1 === ceny.length ? "bold" : "inherit", fontSize: index +1 === ceny.length ? "13px" : "12px", width: "90px"}} className={classes.cell} color='primary'>{row.dzien_tygodnia}</TableCell>
                  <TableCell style={{ textAlign: "center", background: "rgb(240, 255, 235)", color: row.dzien_tygodnia === "sobota" || row.dzien_tygodnia === "niedziela" ? red : primary, fontWeight: index +1 === ceny.length ? "bold" : "inherit", fontSize: index +1 === ceny.length ? "13px" : "12px",  width: "90px" }} className={classes.cell} color='primary'>{row.cena_pokoj}</TableCell> 
                  
                  {/* <TableCell style={{ color: row.dzien_tygodnia === "sobota" || row.dzien_tygodnia === "niedziela" ? red : primary, width: "70px" }} className={classes.cell} color='primary'>{daysFromDate(new Date(this.props.fromDate), index)}</TableCell>
                  <TableCell style={{ color: row.dzien_tygodnia === "sobota" || row.dzien_tygodnia === "niedziela" ? red : primary, width: "90px"}} className={classes.cell} color='primary'>{this.getDayOfWeek(daysFromDate(new Date(this.props.fromDate), index))}</TableCell>
                  <TableCell style={{ color: row.dzien_tygodnia === "sobota" || row.dzien_tygodnia === "niedziela" ? red : primary, }} className={classes.cell} color='primary'>{row.cena_pokoj + ".00"}</TableCell> */}
                  
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </>   
    );
  }
}

const styles = (theme: Theme) => ({
  cell: {
    //color: `${theme.palette.primary.main} !important`,
    padding: "8px !important",
    fontFamily: "\"'Open Sans'\", sans-serif",
    //fontSize: "12px !important",
    fontWeight: 600, 
  },
  header: {
    color: `${theme.palette.primary.main} !important`,
    borderBottom: "1px solid rgb(170, 170, 170) !important",
    padding: "8px !important",
    fontFamily: "\"'Open Sans'\", sans-serif",
    fontSize: "13px !important",
    //fontWeight: "bold !important" as "bold", 
    background: "rgb(240, 240, 240)",
    height: "16px",
    lineHeight: "1rem !important"
  },
  
});

const mapStateToProps = (state: AppState) => ({
  page: state.pageState,
  theme: state.pageState.theme,
  options: state.pageState.options,
  czyPobytZmieniany: state.pageState.czyPobytZmieniany,
  zmienianyPobyt: state.pageState.zmienianyPobyt,
  openFormularzFaktura: state.pageState.openFormularzFaktura,
  optionsValues: state.pageState.optionsValues,
  values: state.pageState.formValues,
  initialValues: {
    nip: state.pageState.daneNIP.nip.trim(), 
    miasto: state.pageState.daneNIP.adres.trim(), 
    nazwa: state.pageState.daneNIP.kontrNazwa.trim(),
    kod: '',
    ulica: '',
    info: ''}
});

export default withStyles(styles)(connect(mapStateToProps)(withTranslation()(NotifierOptions)));